import { useState, useCallback } from 'react';

export const useDisposalData = () => {
  const [disposalData, setDisposalData] = useState({
    originalRc: 'yes',
    kycMatch: 'yes',
    hypothecation: 'no',
    criminalRecord: 'no',
    pendingLiabilities: 'no',
  });

  const updateDisposalData = useCallback((updates) => {
    setDisposalData((prev) => ({
      ...prev,
      ...updates,
    }));
  }, []);

  return { disposalData, updateDisposalData };
};
